import Rest from "../../../class/tool/Rest";
import DrawerEventEntry from "./DrawerEventEntry";

class DrawerEventEntryController {
    #_rest = new Rest();
    _callback = null;
    _baseURL = "drawerevententries";

    index(identifiers = null, nb = null, inventoryType = null, automaticDrawerId = null) {
        let params = "";
        if (identifiers !== null) {
            for (let i in identifiers)
                params += (params.length === 0 ? "?" : "&") + "identifiers[]=" + identifiers[i];
        }
        if (nb !== null && nb > 0) params += (params.length === 0 ? "?" : "&") + "nb=" + nb;
        if (automaticDrawerId !== null && automaticDrawerId > 0) params += (params.length === 0 ? "?" : "&") + "drawer_id=" + automaticDrawerId;

        this.#_rest.sendQuery(
            'GET',
            '/' + this._baseURL + params,
            {},
            this.handleIndex);
    }
    handleIndex = (response, error, status = 200) => {
        let listObjects = [];

        if(status === 200) {
            const data = response.data;

            for(let item in data)
                listObjects.push(new DrawerEventEntry(data[item]));
        }

        this._callback(listObjects, error, status);
    }
}

export default DrawerEventEntryController;